import _ from 'lodash';

const ControlsComponent = {
  template: require('./controls.html'),
  restrict: 'E',
  bindings: {
    updateHistory: '&',
    commandGroups: '<',
  },
  controller: CommandControlsController,
  controllerAs: 'vm',
};

function CommandControlsController($stateParams, CommandsRepo) {
  'ngInject';
  let equipmentId = null;
  const vm = this;

  vm.selectedCommandGroup = null;
  vm.popup = false;
  vm.confirmation = {};

  this.$onInit = () => {
    equipmentId = $stateParams.equipmentId;
  };

  this.$onChanges = () => {
    if (this.commandGroups && this.commandGroups.length) {
      this.selectCommandsGroup(
        [...this.commandGroups].sort((a, b) => a.ordinal - b.ordinal).find((comand) => true),
      );
    }
  };

  this.submitForm = (command, parameter) => {
    this.submitted = true;

    this.confirm(command, parameter.attrs.placeholder, parameter.value);
  };

  //public
  this.selectCommandsGroup = (group) => {
    this.selectedCommandGroup = group;
    this.popup = false;
  };

  const sendCommand = (command) => {
    let bodyParams = {};
    [...command.parameters].forEach((parameter) => {
      bodyParams[parameter.key] = `${parameter.value}`;
    });

    return executeCommand(command.name, bodyParams);
  };

  const executeCommand = (commandName, bodyParams) =>
    CommandsRepo.executeCommand(equipmentId, commandName, bodyParams).then(() => {
      vm.updateHistory();
    });

  this.confirm = (command, commandName, value = null) => {
    vm.confirmation = command
      ? {
          command: command,
          value: value,
          commandName: commandName || command.label,
          show: true,
        }
      : {};
  };

  this.ok = () => {
    this.confirmation = {
      ...this.confirmation,
      sending: true,
    };

    return sendCommand(vm.confirmation.command).then(this.cancel, () => {
      this.confirmation = {
        ...this.confirmation,
        sending: false,
        failed: true,
      };
    });
  };

  this.cancel = () => {
    this.submitted = false;
    this.confirmation = {};
  };
}

export default ControlsComponent;
